import React, { Component } from "react";
import {
  Container,
  Card,
  CardHeader,
  Button,
  CardBody,
  Row,
  Table,
  Col,
} from "reactstrap";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import moment from "moment";
// import DefaultImg from "../../../assets/images/product/Default_img.jpg";

import { ExportToExcel } from "../../Common/ExportToExcel";
import { getSRQreportslist } from "../../../store/Reports/actions";
import "../reports.scss";
var date = new Date(),
  y = date.getFullYear(),
  m = date.getMonth();
class QuotationReportList extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.props.getSRQreportslist({
      ...this.props.params,
      start_date:
        this.props.params.start_date == null ||
        this.props.params.start_date === ""
          ? moment(new Date(y, m, 1)).format("YYYY-MM-DD")
          : this.props.params.start_date,
      end_date:
        this.props.params.end_date == null || this.props.params.end_date === ""
          ? moment(new Date()).add(1, "days").format("YYYY-MM-DD")
          : moment(this.props.params.end_date)
              .add(1, "days")
              .format("YYYY-MM-DD"),
    });
  }

  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <Row>
              <Col md={12}>
                <Card>
                  <CardHeader className="bg-transparent border-bottom no-print">
                    <Link
                      to="/srqreport"
                      className="action-icon text-primary mr-2"
                    >
                      <i className="mdi mdi-arrow-left-bold-circle-outline font-size-20"></i>
                    </Link>
                    <div className="float-right">
                      <div className="d-inline-block ">
                        <ExportToExcel
                          apiData={this.props.SRQ_ReportData.map((Quotation) => {
                            return {
                              "Service Quotation Code": Quotation.code,
                              "SRFQ Code": Quotation.requestforquotation_code,

                              "Vendor Name": Quotation.vendor.name,
                              "Total Price": Quotation.total,
                              "Delivery Date": moment(
                                Quotation.deliverydate
                              ).format("DD-MM-YYYY"),
                              "Other Details": Quotation.description,
                              "Terms & Conditions": Quotation.terms,

                              "Submited On": moment(Quotation.createdon).format(
                                "DD-MM-YYYY"
                              ),
                              "Created By":
                                Quotation.createdby.fullname +
                                " (" +
                                Quotation.createdby.username +
                                ")",
                            };
                          })}
                          topHeader={[
                            "SRI LALITHA ENTERPRISES INDUSTRIES PVT. LTD",
                            "Valuthimmapuram Road, PEDDAPURAM - 533437, E.G. Dist. - AP",
                            "Phone No.0884-2326661, 62, Mobile No.9494127893, Email: purchase@sleipl.com, lalitharice@gmail.com",
                            "",
                            "SR QUOTATION REPORT",
                            "",
                          ]}
                          fileName="QUOTATION_REPORT"
                        />
                        {/* <Button
                          type="button"
                          outline
                          color="secondary"
                          className=" mr-2"
                          onClick={() => this.getExcelReport()}
                        >
                          <i className="ri-file-excel-2-line"></i>
                          <span className="d-none d-inline-block ml-1">
                            Excel
                          </span>
                        </Button> */}
                        {/* <ReactHTMLTableToExcel
                          id="test-table-xls-button"
                          className=" mr-2"
                          // className="download-table-xls-button"
                          table="table-to-xls"
                          filename="tablexls"
                          sheet="tablexls"
                          buttonText="Excel"
                        /> */}
                        <Button
                          type="button"
                          outline
                          color="secondary"
                          className=" ml-2"
                          onClick={() => window.print()}
                        >
                          <i className="mdi  mdi-printer"></i>
                          <span className="d-none d-inline-block ml-1">
                            Print
                          </span>
                        </Button>
                      </div>
                    </div>
                  </CardHeader>
                  <CardBody className="pt-2">
                    <div className="text-center">
                      <span className="display_none printme">
                        <h5 className="card-title-18 pt-2 ">
                          SRI LALITHA ENTERPRISES INDUSTRIES PVT. LTD
                        </h5>
                        <p className="card-title-14 pt-2 mb-0">
                          Valuthimmapuram Road, PEDDAPURAM - 533437, E.G. Dist.
                          - AP
                        </p>
                        <p className="card-title-14 pt-2">
                          Phone No.0884-2326661, 62, Mobile No.9494127893,
                          Email: purchase@sleipl.com, lalitharice@gmail.com
                        </p>
                        <hr />
                      </span>
                      <h5 className="card-title-16 pt-3 ">
                        SR QUOTATION REPORT ({" "}
                        {this.props.params.start_date == null ||
                        this.props.params.start_date === ""
                          ? moment(new Date(y, m, 1)).format(
                              "DD-MM-YYYY"
                            )
                          : moment(this.props.params.start_date).format(
                            "DD-MM-YYYY"
                          )}{" "}
                        TO{" "}
                        {moment(this.props.params.end_date).format(
                          "DD-MM-YYYY"
                        )}{" "}
                        )
                      </h5>
                    </div>

                    <div className="table-responsive m-0">
                      <Table
                        bordered
                        hover
                        className="mb-0 p-0 table-centered"
                        id="table-to-xls"
                      >
                        <thead className="bg-light text-center ">
                          <tr className="bg-light">
                            <th style={{ width: "10%" }}>
                              <b>Service Quotation Code</b>
                            </th>
                            <th style={{ width: "10%" }}>
                              <b>SRFQ Code</b>
                            </th>

                            <th style={{ width: "10%" }}>
                              <b>Vendor Name</b>
                            </th>
                            <th style={{ width: "10%" }}>
                              <b>Total Price</b>
                            </th>
                            <th style={{ width: "10%" }}>
                              <b>Delivery Date</b>
                            </th>
                            <th style={{ width: "15%" }}>
                              <b>Other Details</b>
                            </th>
                            <th style={{ width: "15%" }}>
                              <b>Terms & Conditions</b>
                            </th>
                            <th style={{ width: "10%" }}>
                              <b>Submited On</b>
                            </th>
                            <th style={{ width: "10%" }}>
                              <b>Created By</b>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.props.SRQ_ReportData.length !== 0 ? (
                            <>
                              {this.props.SRQ_ReportData.map((Quotation, key) => (
                                <>
                                  <tr key={key} className="text-center">
                                    <td>{Quotation.code}</td>
                                    <td>
                                      {Quotation.servicerequestforquotation_code}
                                    </td>
                                    <td>{Quotation.vendor.name}</td>
                                    <td>{Quotation.total}</td>
                                    <td>
                                      {moment(Quotation.deliverydate).format(
                                        "DD-MM-YYYY"
                                      )}
                                    </td>
                                    <td>{Quotation.description}</td>
                                    <td>{Quotation.terms}</td>

                                    <td>
                                      {moment(Quotation.createdon).format(
                                        "DD-MM-YYYY"
                                      )}
                                    </td>

                                    <td>
                                      {Quotation.createdby.fullname} (
                                      {Quotation.createdby.username})
                                    </td>
                                  </tr>
                                </>
                              ))}
                            </>
                          ) : (
                            <tr>
                              <td colspan="9" className="text-center">
                                <span className="font-size-18 text-danger">
                                  Data not available
                                </span>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const { params, reportType, Reportdata, SRQ_ReportData } = state.reports;
  return {
    params,
    reportType,
    Reportdata,
    SRQ_ReportData,
  };
};

export default connect(mapStatetoProps, {
  getSRQreportslist,
})(QuotationReportList);
